export default __webpack_public_path__ + "static/media/glyphicons-halflings-regular.5be1347c.eot";